const handler = tracker => ({
  trackTechnicalComitteeTab: metadata => {
    tracker().trackEvent("Ha abierto la pestaña de comité técnico", metadata)
  }
})

export default handler